import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: null,
  data: [],
};

const groupsPerDesignerReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.MANAGER_GROUPS_PER_DESIGNER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.MANAGER_GROUPS_PER_DESIGNER_SUCCESS:
      return {
        loading: false,
        error: null,
        data: Array.isArray(payload) ? payload.map(({ id, value }) => ({ id, value })) : [],
      };
    case actionTypes.MANAGER_GROUPS_PER_DESIGNER_ERROR:
      return {
        error: payload,
        loading: false,
        data: [],
      };
    default:
      return state;
  }
};

export default groupsPerDesignerReducer;
